// extracted by mini-css-extract-plugin
var _1 = "UpsellCTA_description__JQinH";
var _2 = "UpsellCTA_title__sC3iG";
var _3 = "UpsellCTA_upsellBox__yHDpx";
export { _1 as "description", _2 as "title", _3 as "upsellBox" }
